module.exports = __webpack_public_path__ + "assets/img/A4-1.280a1cc3.jpg";